<template>
    <hr class="d-divder" :class="`${spacing} ${shade}`">
</template>

<script setup lang="ts">
    import {computed} from "vue";

    import {getComponentShade} from "../utils/theme";

    import type {ComponentThemes} from "@songfinch/types";

    type DDividerPropsType = {
        spacing?: "large" | "medium" | "small" | "tight";
        theme?: ComponentThemes;
    };

    const props = withDefaults(defineProps<DDividerPropsType>(), {
        spacing: "medium",
        theme: "light",
    });

    const shade = computed(() => getComponentShade(props.theme));
</script>

<style lang="scss" scoped>
.d-divder {
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  border-bottom: 1px solid;
  background-color: transparent;
}

.dark {
  border-color: var(--white-tint-20);
}

.light {
  border-color: var(--soft-black-tint-20);
}

.large {
  padding-top: var(--size-64);
  margin-bottom: var(--size-64);
}

.medium {
  padding-top: var(--size-48);
  margin-bottom: var(--size-48);
}

.small {
  padding-top: var(--size-24);
  margin-bottom: var(--size-24);
}

.tight {
  padding-top: var(--size-8);
  margin-bottom: var(--size-8);
}
</style>
